import { useGetReserve, type ReserveRoomResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center, Grid, Spinner } from "@chakra-ui/react";
import { CustomText, Wrapper } from "./bookModalContent.style";

export const BookModalContent = ({ roomIdx, roomName }: { roomIdx: number; roomName: string }) => {
    const { data } = useGetReserve<ReserveRoomResponse>({ section: "view", roomIdx });
    const { isTablet, isMobile } = MEDIA();
    const tabletBoxHeight = isTablet ? "300px" : "360px";

    return (
        <Wrapper>
            <CustomText position="sticky" top="0" p="16px 24px" as="h4">
                {roomName}
            </CustomText>
            {data ? (
                <Grid w="100%" gridTemplateColumns="repeat(2, 1fr)" gridGap="4px">
                    {data.imgList.map((img) => (
                        <Box
                            key={img.imgUrl}
                            w="100%"
                            h={isMobile ? "160px" : tabletBoxHeight}
                            background={`url(${img.imgUrl}) no-repeat center/cover`}
                        ></Box>
                    ))}
                </Grid>
            ) : (
                <Center h="100%">
                    {/* 스피너 위치 처리 */}
                    <Spinner />
                </Center>
            )}
        </Wrapper>
    );
};
